module.exports = __webpack_public_path__ + "static/img/stay-option-icon-cityview.dba3b040.svg";